import React from 'react';
import { motion } from 'framer-motion';
import { CreditCard } from 'lucide-react';
import { SQUARE_PAYMENT_URL } from './data';
type PayButtonProps = {
  /** 'compact' for tight spots like the navbar, 'full' for content areas. */
  size?: 'compact' | 'full';
  label?: string;
  className?: string;
  offsetColor?: string;
};
export function PayButton({
  size = 'compact',
  label = 'Pagar',
  className = '',
  offsetColor = 'focus-visible:ring-offset-[#faf0e7]'
}: PayButtonProps) {
  const sizeClassName = size === 'compact' ? 'gap-1.5 px-3 py-2 text-[9px] tracking-[2px] sm:px-4 sm:text-[10px] sm:tracking-[2.5px]' : 'gap-2 px-7 py-3.5 text-[10px] tracking-[3px]';
  return <motion.a href={SQUARE_PAYMENT_URL} target="_blank" rel="noreferrer" whileHover={{
    y: -1
  }} whileTap={{
    scale: 0.97
  }} aria-label={`${label} en línea de forma segura con Square`} className={`metallic-reserve-button inline-flex items-center justify-center font-body font-semibold uppercase text-white outline-none focus-visible:ring-2 focus-visible:ring-champagne ${offsetColor} ${sizeClassName} ${className}`} data-id="element-315" data-mp="8q8586a9fktn">
      <CreditCard className="h-3.5 w-3.5 shrink-0" strokeWidth={2} data-id="element-316" data-mp="2xj4mbn6n1ilc" />
      {label}
    </motion.a>;
}